import { Camera } from "lucide-react";
import { Link } from "react-router-dom";

export default function Gallery() {
  return (
    <div className="bg-[#0a0a0b] text-white pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="gallery-hero">
        <p className="label-overline">Gallery</p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-5 tracking-tight leading-[1.05] max-w-4xl">
          A glimpse, <span className="italic text-[#c5a059]">coming soon</span>.
        </h1>
        <p className="text-[#cfcfd2] mt-8 max-w-2xl leading-relaxed">
          Photography from our inaugural layout will appear here as the site develops.
          Walk-through visuals, master plan renders, and aerial shots will be added closer to launch.
        </p>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-12 pb-28" data-testid="gallery-empty-state">
        <div className="relative rounded-2xl border border-[#2a2a2d] bg-[#0f0f11] p-12 lg:p-20 text-center overflow-hidden">
          <div className="absolute inset-0 grain pointer-events-none" />
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-[#c5a059]/40 text-[#c5a059] mb-6">
            <Camera size={24} strokeWidth={1.4} />
          </span>
          <p className="label-overline">Launching Soon</p>
          <h2 className="font-serif text-3xl md:text-4xl mt-4">Visuals will be unveiled with the launch.</h2>
          <p className="text-[#8f8f94] mt-5 max-w-md mx-auto leading-relaxed">
            We're carefully documenting every step of our inaugural project — from boundary
            demarcation to landscaping. Sign up to be notified the moment our gallery goes live.
          </p>
          <Link
            to="/contact"
            data-testid="gallery-notify-cta"
            className="inline-flex btn-gold px-7 py-3 rounded-full text-sm font-medium mt-8"
          >
            Notify me at launch
          </Link>
        </div>
      </section>
    </div>
  );
}
